import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { RequireRole } from '@/core/permissions';

const NotificationsPage = lazy(() =>
  import('./pages/NotificationsPage').then(m => ({ default: m.NotificationsPage }))
);

/**
 * The inbox is strictly first-person server-side (the queryset is filtered to
 * the caller's own Member), so every role reaches it — spelled out rather than
 * omitted, since an omitted list would admit an unrecognised role
 * (deny-by-default, FE-ADR-005).
 */
export const notificationRoutes = (
  <Route element={<RequireRole roles={['admin', 'teacher', 'pupil', 'parent']} />}>
    <Route path="/notifications" element={<NotificationsPage />} />
  </Route>
);
